// extracted by mini-css-extract-plugin
module.exports = {"container":"_5b10bb2305--container--rqt0K","content":"_5b10bb2305--content--KbVBM","note":"_5b10bb2305--note--K3WcI"};